import SideBar from "../components/SideBar/SideBar";
import TopBar from '../custom_components/TopBar/TopBar';

const ProtectedLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      <SideBar />
      <main>
        <TopBar />
        {children}
        <p>v.0.0.3</p>
      </main>
    </>
  );
};

export default ProtectedLayout;